import { clsx } from "@trydig/ui";
import type { MarqueeStoryblok } from "~/generated/sb/blok-types";
import styles from "./MarqueeBlok.module.css";

export const MarqueeBlok = ({ blok }: { blok: MarqueeStoryblok }) => {
	return (
		<div className={styles.marquee}>
			<div className={styles.marquee__element}>
				<p>{blok.text}</p>
			</div>
			<div className={clsx(styles.marquee__element, styles.second__marquee)}>
				<p>{blok.text}</p>
			</div>
		</div>
	);
};
